/* eslint-disable */
export default {
  removeMeetingWarning:
    'La función de programación está descontinuada. Utilice {app} para programar reuniones por video.',
  scheduleMeetingTips:
    'Tenga en cuenta que eliminamos las reuniones de esta aplicación. Para usarlas, recomendamos {app}.',
  migrateToPluginAlert:
    'Nota: Esta aplicación no funcionará con la versión 2016 de Outlook y versiones inferiores ni con Internet Explorer 11. Actualice Outlook o cambie a Microsoft Edge, o bien, cambie a {app}',
} as const;

// @key: @#@"removeMeetingWarning"@#@ @source: @#@"The scheduling feature is discontinued. Please use the {app} to schedule your video meetings."@#@
// @key: @#@"scheduleMeetingTips"@#@ @source: @#@"Please note that we removed meetings from this app. To use meetings, we recommend the {app}."@#@
// @key: @#@"migrateToPluginAlert"@#@ @source: @#@"Note: This app will not work with Outlook version 2016 and below and Internet Explorer 11. Please upgrade your Outlook or switch to Microsoft Edge, or alternately, switch to {app}"@#@
